import { useCallback } from 'react';

import { useTheme } from '@mui/material';

import useRegularOptions from '@/components/Chart/hooks/options/useRegularOptions';
import { createChartAppearance } from '@/components/Chart/theme/chartAppearance';
import type {
  ExtendedOptions,
  ExtendedSeriesOptionsType
} from '@/components/Chart/types/highcharts';
import { withSpotSeriesAppearance } from '@/components/Chart/utils/applyChartSeriesAppearance';

const useSpotOptions = (height?: number, isDhChart = false) => {
  const { createOptions: createRegularOptions } = useRegularOptions(height, isDhChart);
  const theme = useTheme();

  const createOptions = useCallback(
    (chartSeries: ExtendedSeriesOptionsType[], hiddenSeriesIds: string[] = []): ExtendedOptions => {
      const appearance = createChartAppearance(theme, 'regular');
      const coloredSeries = chartSeries.map(series => withSpotSeriesAppearance(series, appearance));
      return createRegularOptions(coloredSeries, hiddenSeriesIds);
    },
    [createRegularOptions, theme]
  );

  return { createOptions };
};

export default useSpotOptions;
